/**
 * Tag Filter Component
 *
 * Filter notes by tag categories
 * Shows tag counts and supports multi-select
 */

import './TagFilter.css';

interface TagFilterProps {
  tags: string[];
  selectedTags: string[];
  onTagSelect: (tags: string[]) => void;
  noteCounts: Record<string, number>;
}

export function TagFilter({
  tags,
  selectedTags,
  onTagSelect,
  noteCounts,
}: TagFilterProps): JSX.Element {
  const totalNotes = Object.values(noteCounts).reduce((sum, count) => sum + count, 0);

  const handleTagClick = (tag: string): void => {
    if (selectedTags.includes(tag)) {
      onTagSelect(selectedTags.filter((t) => t !== tag));
    } else {
      onTagSelect([...selectedTags, tag]);
    }
  };

  const handleAllClick = (): void => {
    onTagSelect([]);
  };

  return (
    <div className="tag-filter">
      <button
        type="button"
        className={`tag-filter__tag ${selectedTags.length === 0 ? 'tag-filter__tag--active' : ''}`}
        onClick={handleAllClick}
      >
        All
        <span className="tag-filter__count">{totalNotes}</span>
      </button>

      {tags.map((tag) => {
        const count = noteCounts[tag] ?? 0;
        if (count === 0) return null;

        return (
          <button
            key={tag}
            type="button"
            className={`tag-filter__tag ${selectedTags.includes(tag) ? 'tag-filter__tag--active' : ''}`}
            onClick={() => handleTagClick(tag)}
          >
            {tag}
            <span className="tag-filter__count">{count}</span>
          </button>
        );
      })}
    </div>
  );
}
